"use strict";
export const CostsMock = (mock) => {
  mock.onGet("/v7/client/account/coin").reply((config) => {
    let _response = {
      "coin": 427.2,
      "coupon": 5,
      "vdCard": 0,
      "goods": [
        {
          "guid": "goods_spec_3ea59cb394084a93b4bb69efc720836b",
          "model": "coin",
          "present_count": 0,
          "price": 5e3,
          "spec_goods_number": 5e3,
          "spec_name": "5000\u91D1\u8C46\u5957\u9910",
          "type": "fixed"
        },
        {
          "guid": "goods_spec_4b274292c3c74ab1b3aa007551b73dfd",
          "model": "coin",
          "present_count": 0,
          "price": 1e4,
          "spec_goods_number": 1e4,
          "spec_name": "10000\u91D1\u8C46\u5957\u9910",
          "type": "fixed"
        },
        {
          "guid": "goods_spec_4b274292c3c74ab1b3aa007551b73dfd_20000",
          "model": "coin",
          "present_count": 0,
          "price": 2e4,
          "spec_goods_number": 2e4,
          "spec_name": "20000\u91D1\u8C46\u5957\u9910",
          "type": "fixed"
        },
        {
          "guid": "goods_spec_74d3a6912d2e421fbecf27eb9d9dd24c",
          "model": "coin",
          "present_count": 0,
          "price": 1,
          "spec_goods_number": 1,
          "spec_name": "\u81EA\u5B9A\u4E49\u5145\u503C",
          "type": "custom"
        }
      ],
      "invite_url": "https://www.kuajingvs.com/?c=5183FFAD&ss=001&t=0",
      "model": "account_coin"
    };
    return [200, _response];
  });
  mock.onGet("/v7/client/coin_history").reply((config) => {
    let _response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210512110215401759\u4E2D\u4F7F\u75281.2\u4E2A\u91D1\u8C46",
            "coins": -1.2,
            "balance": 427.2,
            "createdTime": 1620788535e3,
            "id": "coin_history_3780bc4fa8b343f7935ff5508dda2fb9",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210507171000731484\u4E2D\u4F7F\u752820.0\u4E2A\u91D1\u8C46",
            "coins": -20,
            "balance": 428.4,
            "createdTime": 1620378601e3,
            "id": "coin_history_365091be602b42678542e02525a878b0",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210507115805965301\u4E2D\u4F7F\u752859.0\u4E2A\u91D1\u8C46",
            "coins": -59,
            "balance": 448.4,
            "createdTime": 1620359885e3,
            "id": "coin_history_393df91214614c189e50c1294b78a9c5",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u5185\u90E8\u8D26\u53F7",
            "coins": 500,
            "balance": 507.4,
            "createdTime": 1620359841e3,
            "id": "coin_history_4879dfd7195b48879a4c4528c8019304",
            "name": "\u8DE8\u5883\u536B\u58EB",
            "account_guid": "admin_b232a496fb9e4301870e129f23323216_hr"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210506134158460558\u4E2D\u4F7F\u75281.6\u4E2A\u91D1\u8C46",
            "coins": -1.6,
            "balance": 7.4,
            "createdTime": 1620279718e3,
            "id": "coin_history_cf5464d3930c413ca2c8289254bd412c",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210506133538777561\u4E2D\u4F7F\u752869.0\u4E2A\u91D1\u8C46",
            "coins": -69,
            "balance": 9,
            "createdTime": 1620279338e3,
            "id": "coin_history_8fdb2015582a488581af8cf8592cc1a4",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210504150252109486\u4E2D\u4F7F\u75281.6\u4E2A\u91D1\u8C46",
            "coins": -1.6,
            "balance": 78,
            "createdTime": 1620111772e3,
            "id": "coin_history_3ee4d5865f434e879266710cedd0626e",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210503121203854960\u4E2D\u4F7F\u75281.6\u4E2A\u91D1\u8C46",
            "coins": -1.6,
            "balance": 79.6,
            "createdTime": 1620015123e3,
            "id": "coin_history_e96dffcc0be047e1b79a57308f558905",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210430111704745999\u4E2D\u4F7F\u75281.6\u4E2A\u91D1\u8C46",
            "coins": -1.6,
            "balance": 81.2,
            "createdTime": 1619752624e3,
            "id": "coin_history_0b22443cac64486790b6a82ba75cf319",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          },
          {
            "model": "coin.history.item",
            "comment": "\u8BA2\u535520210427134231030579\u4E2D\u4F7F\u75281.6\u4E2A\u91D1\u8C46",
            "coins": -1.6,
            "balance": 82.8,
            "createdTime": 1619502152e3,
            "id": "coin_history_12b46762523946a6b11b3118daf13ac9",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account_guid": "account_aab33b56853824d06868b73b63a0a1e3a"
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 128,
        "size": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/client/orders").reply((config) => {
    let _response = {
      "model": "grid.result",
      "page": {
        "current": 1,
        "model": "page",
        "size": 10,
        "total": 133
      },
      "result": {
        "datas": [
          {
            "consume": "\xA50.0",
            "guid": "order_9792825db11a4306bd2d1a8a88f7ca5d",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620788535e3,
            "order_no": "20210512110215401759",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.2,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_32727a21413c4d7dbfdb8ee1b6080a0a",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620378601e3,
            "order_no": "20210507171000731484",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 20,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_5d6c70e984cd410084c4f62470cc1539",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620359885e3,
            "order_no": "20210507115805965301",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 59,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_795457160920452e8975d109dbb95aa6",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620279718e3,
            "order_no": "20210506134158460558",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.6,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_fd318412221d49d1905797a3540f7224",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620279338e3,
            "order_no": "20210506133538777561",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 69,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_b4234920704e4afb8f21585fd1ae86d9",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620111772e3,
            "order_no": "20210504150252109486",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.6,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_ab7a69246f1e484f8bd36b047742f191",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1620015123e3,
            "order_no": "20210503121203854960",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.6,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_e8166a509ffe4b259ccdd89cb68c5541",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1619752624e3,
            "order_no": "20210430111704745999",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.6,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_3e5459a251514d569d6a9ac2d07f7164",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1619502151e3,
            "order_no": "20210427134231030579",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.6,
            "should_pay_discount_coupon": null
          },
          {
            "consume": "\xA50.0",
            "guid": "order_7b38786d406b4b5a968eec0c611393cb",
            "invoice_status_desc": "\u672A\u7533\u8BF7\u53D1\u7968",
            "model": "order",
            "operator_name": "\u7BA1\u7406\u5458",
            "order_created_time": 1619404746e3,
            "order_no": "20210426103905381070",
            "pay_platform": "\u91D1\u8C46",
            "should_pay_coin": 1.6,
            "should_pay_discount_coupon": null
          }
        ],
        "model": "data.set",
        "total": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/client/paidservice").reply((config) => {
    let _response = {
      "model": "grid.result",
      "page": {
        "current": 1,
        "model": "page",
        "size": 10,
        "total": 133
      },
      "result": {
        "datas": [
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          },
          {
            "guid": "g_9792825db11a4306bd2d1a8a88f7ca5d",
            "name": "\u67D0\u4E2A\u5E94\u7528\u7684\u540D\u5B57",
            "model": "paid.service",
            "cost": "\uFFE599/\u6708",
            "valid_date": 23,
            "expire_date": 1620788535e3
          }
        ],
        "model": "data.set",
        "total": 10
      }
    };
    return [200, _response];
  });
};
